/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Communities_Hub_TitleInputs */

const en_communities_hub_title = /** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Communities`)
};

const es_communities_hub_title = /** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis Comunidades`)
};

const fr_communities_hub_title = /** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes Communautés`)
};

const de_communities_hub_title = /** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Communities`)
};

const id_communities_hub_title = /** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas Saya`)
};

/** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */
const ja_communities_hub_title = en_communities_hub_title;

/** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */
const zh_communities_hub_title = en_communities_hub_title;

/** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */
const ar_communities_hub_title = en_communities_hub_title;

/** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */
const it_communities_hub_title = en_communities_hub_title;

/** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */
const ru_communities_hub_title = en_communities_hub_title;

/** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */
const pt_communities_hub_title = en_communities_hub_title;

/** @type {(inputs: Communities_Hub_TitleInputs) => LocalizedString} */
const ko_communities_hub_title = en_communities_hub_title;

/**
* | output |
* | --- |
* | "My Communities" |
*
* @param {Communities_Hub_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const communities_hub_title = /** @type {((inputs?: Communities_Hub_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Communities_Hub_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_communities_hub_title(inputs)
	if (locale === "es") return es_communities_hub_title(inputs)
	if (locale === "fr") return fr_communities_hub_title(inputs)
	if (locale === "de") return de_communities_hub_title(inputs)
	if (locale === "ja") return ja_communities_hub_title(inputs)
	if (locale === "zh") return zh_communities_hub_title(inputs)
	if (locale === "ar") return ar_communities_hub_title(inputs)
	if (locale === "id") return id_communities_hub_title(inputs)
	if (locale === "it") return it_communities_hub_title(inputs)
	if (locale === "ru") return ru_communities_hub_title(inputs)
	if (locale === "pt") return pt_communities_hub_title(inputs)
	return ko_communities_hub_title(inputs)
});